module.exports = __webpack_public_path__ + "static/img/modular2.956f4192.png";